export default __webpack_public_path__ + "static/media/backgroundImage.b4ebe3b9.png";